import styled from "styled-components";

export const InfoContainer = styled.div`
	padding: 0.825rem;
	margin-bottom: 0.825rem;
	border-radius: 0.4rem;
	border: 1px solid #e1e1e1;
	border-top: 2px solid #f7ba01;
`;
